import type { IssueStatusId } from '@atlassian/jira-shared-types/src/general.tsx';
import type { FilterableIssue, MatcherCreator } from '../types.tsx';

export const statusMatcherCreator: MatcherCreator<IssueStatusId[], FilterableIssue> = (
	statusFilter,
) => {
	const statusSet = new Set(statusFilter);
	return ({ statusId }) => !!statusId && statusSet.has(statusId);
};
